import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { NumberSelector } from "./number-selector";
import { CongratsDialog } from "./congrats-dialog";
import {
  getSingleNetworkSelectionData,
  saveSingleNetworkSelectionData,
} from "utils/purchase-flow-storage";

import { Button } from "app/components/ui/button";

type FormValues = {
  selectedLabel: number;
  mdn?: string;
};

export const TypeOfNumber = () => {
  const savedData = getSingleNetworkSelectionData();
  const form = useForm<FormValues>({
    defaultValues: {
      selectedLabel: savedData?.typeOfNumber?.selectedLabel ?? undefined,
      mdn: savedData?.typeOfNumber?.mdn || "",
    },
  });
  const [isPortValidated, setIsPortValidated] = useState(false);
  const [showCongratsDialog, setShowCongratsDialog] = useState(false);
  const selectedLabel = form.watch("selectedLabel");
  const mdn = form.watch("mdn");

  // Save to sessionStorage when form values change
  useEffect(() => {
    const subscription = form.watch((value) => {
      saveSingleNetworkSelectionData({
        typeOfNumber: {
          selectedLabel: value.selectedLabel,
          mdn: value.mdn || "",
        },
      });
    });
    return () => subscription.unsubscribe();
  }, [form]);

  const handleValidationSuccess = () => {
    setIsPortValidated(true);
  };

  // Check if continue button should be shown
  const shouldShowContinueButton = () => {
    if (selectedLabel === 0) {
      return true; // Show for "I want a new number"
    }

    if (selectedLabel === 1) {
      // Check if validatePorting API response has eligibilityFlag as "true"
      return isPortValidated;
    }

    return false;
  };

  return (
    <React.Fragment>
      <div className="w-full max-w-[31rem] md:mx-auto">
        <NumberSelector
          form={form}
          onValidationSuccess={handleValidationSuccess}
        />
        {shouldShowContinueButton() && (
          <Button
            type="button"
            variant="primary"
            onClick={() => setShowCongratsDialog(true)}
          >
            Continue
          </Button>
        )}
      </div>
      <CongratsDialog
        showDialog={showCongratsDialog}
        setShowDialog={setShowCongratsDialog}
      />
    </React.Fragment>
  );
};
